import { render, staticRenderFns } from "./ProfileSwitcher.vue?vue&type=template&id=325838b2&lang=pug&"
import script from "./ProfileSwitcher.vue?vue&type=script&lang=ts&"
export * from "./ProfileSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSwitcher.vue?vue&type=style&index=0&id=325838b2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports